<template>
  <div>
    <portal-target
      v-show="showList"
      name="layout-main"
      class="layout-main panel-scroll-full"
    >
      <div class="panel-list panel-fixed">
        <div class="panel-header">
          <h1 class="page-header mr-2 d-flex align-items-center">
            {{ titleWithYardName | translate }}
          </h1>
          <ol class="breadcrumb pull-right">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'dashboard'}">
                {{"Dashboard"}}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: YARD_ROUTES.YARD_LIST }">
                {{$t("Yards")}}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: YARD_ROUTES.YARD_DETAIL, params: { id: $route.params.id } }">
                {{$t("Yard")}}
              </router-link>
            </li>
            <li class="breadcrumb-item">{{ title | translate }}</li>
          </ol>
        </div>
        <component-edit
          v-if="showEditForm && editComponent"
          :technicians="list.results"
          :yard="$route.params.id"
          :editParams="editParams"
          @on-submit="refreshListAfterSubmit"
          @close-form='closeEditForm'
        />

        <advanced-search
          v-show="showAdvancedSearch"
          v-if="toggleAdvancedSearch"
          :fields="searchFields"
          :reset="reset"
          @search="addFiltersToInstance"
          @reset="removeFiltersToInstance"
          @active="activeFilters = $event"
        />
        <panel :title="title" :no-button="true">
          <thux-list-component
            :fields="getFields"
            :pagination="getPaginationFields"
            @select-per-page="changePerPage"
            @change-page="changePage"
            :action-select="getActionSelectFields"
            @select-action="setAction"
            @select-or-deselect-all-queryset="selectOrDeselectAllQueryset"
            @do-action="doAction($event, fieldName)"
            :advanced-search="getAdvancedSearchFields"
            @show-advanced-search="openAdvancedSearch"
            @open-edit-form="openEditForm()"
            @open-detail-form="openDetailForm()"
          >
            <template slot="body">
              <component-table
                :list="list.results"
                :goBack="goBack"
                :params="tableParams"
                @open-edit-form="openEditForm"
                @open-detail-form="openDetailForm"
                @refresh-list="refreshListAfterSubmit"
              />
            </template>
          </thux-list-component>
        </panel>
      </div>
    </portal-target>
    <router-view />
    <portal-target
      v-if="showCommonFilters"
      v-show="showList"
      name="layout-sidebar"
      class="layout-side panel-scroll-full"
    >
      <button
        @click.prevent="closeRightSidebar"
        class="btn btn-primary text-uppercase w-100 mb-4"
        :aria-label="$t('Close')"
      >
        <i class="fas fa-times" />
        {{ $t('Hide sidebar') }}
      </button>
      <common-filters />
    </portal-target>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { ROUTES as YARD_ROUTES } from '../router'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxListMixin from '../../../../components/thux-list/ThuxListMixin'

import YardTechniciansTable from './YardTechniciansTable'
import YardTechnicianEdit from './YardTechnicianEdit'
import { TYPES as YARD_TECHNICIAN_TYPES } from '../../yard-technician/store'
import { TYPES as YARD_TYPES } from '../store'

export default {
  name: 'YardTechniciansList',
  mixins: [ThuxListMixin],
  components: {
    'component-table': YardTechniciansTable,
    'component-edit': YardTechnicianEdit
  },
  data () {
    return {
      YARD_ROUTES,
      title: this.$t('Technicians'),
      rolePerm: ['yard_yardtechnician_list'],
      actionEnablePermission: ['yard_yardtechnician_enable'],
      actionDisablePermission: ['yard_yardtechnician_disable'],
      showCommonFilters: false,
      searchFields: [
        { key: 'filter__technician__first_name__icontains', placeholder: this.$t('First name'), type: 'text', col: 4 },
        { key: 'filter__technician__last_name__icontains', placeholder: this.$t('Last name'), type: 'text', col: 4 },
        { key: 'filter__technician__organization_contacts__roles__name__icontains', placeholder: this.$t('Role'), type: 'text', col: 4 }
      ]
    }
  },
  created () {
    this.yardRetrieve({ id: this.$route.params.id })
  },
  computed: {
    ...mapGetters({
      ...YARD_TECHNICIAN_TYPES.GENERIC.yard.yardtechnician.LIST.GETTERS,
      yardDetail: YARD_TYPES.GENERIC.yard.yard.DETAIL.GETTERS.detail
    }),
    titleWithYardName () {
      if (this.yardDetail && this.yardDetail.code) {
        return `${this.$t('Technicians')} ${this.yardDetail.name ? this.yardDetail.name : this.yardDetail.customer_name} (${this.yardDetail.code})`
      }
      if (this.list && this.list.results && this.list.results.length > 0) {
        const yardName = this.list.results[0].yard_name ? `(${this.list.results[0].yard_name})` : ''
        return `${this.$t('Technicians')} ${yardName}`
      }
      return this.$t('Technicians')
    },
    showList () {
      return true
    },
    canSeeActionSelect () {
      return false
    },
    canAddInstance () {
      return hasPerm('yard_yardtechnician_create')
    }
  },
  methods: {
    ...mapMutations({
      setSelectedList: YARD_TECHNICIAN_TYPES.GENERIC.yard.yardtechnician.LIST.MUTATIONS.setSelectedList,
      setSelectAll: YARD_TECHNICIAN_TYPES.GENERIC.yard.yardtechnician.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...YARD_TECHNICIAN_TYPES.GENERIC.yard.yardtechnician.LIST.ACTIONS,
      yardRetrieve: YARD_TYPES.GENERIC.yard.yard.DETAIL.ACTIONS.retrieve
    }),
    getComponentList () {
      this.setFilters({ filter__yard_id: this.$route.params.id })
    },
    refreshListAfterSubmit () {
      this.getComponentList()
      this.closeEditForm()
    },
    closeEditForm () {
      this.$set(this, 'showDetailForm', false)
      this.$set(this, 'showEditForm', false)
    }
  }
}
</script>
